<template>
  <div class="ticket-price-list-mobile">
    <v-expansion-panels
      v-if="tickets.length !== 0"
      v-model="panels"
      multiple
      readonly
    >
      <v-expansion-panel
        v-for="(ticket, index) of tickets"
        :key="index"
        class="elevation-0 mb-4"
      >
        <v-expansion-panel-header hide-actions>
          <v-row align="center" class="flex-row">
            <v-col>
              <p class="font-weight-bold ma-auto">
                {{ ticket.ticketConfig.name }}
              </p>
              <p
                v-if="ticket.ticketConfig.ended"
                class="small-2 mb-0 sold-out ma-auto"
              >
                {{ $t('cart.soldOut').toUpperCase() }}
              </p>
              <p
                v-else-if="!ticket.ticketConfig.started"
                class="small-2 mb-0 sold-out ma-auto"
              >
                {{ $t('cart.ticketSaleNotStarted') }}
              </p>
            </v-col>
            <v-col>
              <p class="ma-auto">{{ ticket.price }} {{ ticket.currency }}</p>
            </v-col>
            <v-col>
              <!-- as there is no seat_id in offers right now -->
              <p class="ma-auto">{{ $t('ticket.seat') }}: -</p>
            </v-col>
            <v-col>
              <v-btn
                height="32px"
                width="34px"
                depressed
                elevation="0"
                class="add-cart-button ma-auto"
                @click="$emit('add', ticket)"
              >
                {{ $t('buyTickets.add') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-else>
      <p class="MOBILE_h16_Semibold info-message">
        {{ $t('tickets.secondaryMarket.noTickets') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TicketPriceListMobileSM',
  props: {
    ticketConfig: {
      type: Array,
      default() {
        return [];
      }
    },
    tickets: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      panels: this.tickets.map((o, i) => i)
    };
  }
};
</script>

<style lang="scss" scoped>
.ticket-price-list-mobile {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  .info-message {
    color: var(--v-textPrimary-base);
    padding: 0 24px;
  }
  p {
    color: var(--v-textPrimary-base);
    font-size: 1rem;
  }
  .sold-out {
    color: red;
  }
  .v-expansion-panels {
    z-index: 0;
    display: block;
  }
  .ticket-price-item {
    p {
      font-size: 9px;
      font-weight: 400;
      color: var(--v-textPrimary-base);
    }
    .title {
      line-height: 200%;
      color: var(--v-textPrimary-base);
    }

    .title.sold-out {
      color: #6b6b6b;
    }

    .price {
      text-align: right;
      line-height: 200%;
      color: var(--v-primary-lighten3);
    }

    .price.sold-out {
      color: red;
    }
  }
  .theme--dark.v-expansion-panels .v-expansion-panel {
    background-color: var(--v-primary-lighten1);
    border-width: 1px;
    border-radius: 8px;
    border-style: solid;
    border-color: var(--v-primary-lighten3);
  }
  .v-expansion-panel:before {
    box-shadow:
      0 0 0 0 rgba(0, 0, 0, 0.2),
      0 0 0 0 rgba(0, 0, 0, 0.14),
      0 0 0 0 rgba(0, 0, 0, 0.12) !important;
  }
  .v-expansion-panel-header {
    padding: 0 16px;
  }
  .v-expansion-panel-content {
    padding: 16px;
    border-top: 1px solid var(--v-primary-lighten3);
    background-color: var(--v-primary-lighten1);
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    .v-btn:not(.v-btn--round).v-size--default {
      padding: 0;
      min-width: 0;
      border-radius: 0;
    }
    .theme--dark.v-btn.v-btn--has-bg {
      background-color: var(--v-BAMGrey-darken3);
    }
  }
  .selected-quantity {
    width: 34px;
  }
  .divider {
    margin-top: 12px;
    margin-bottom: 12px;
    border-top: 1px solid var(--v-primary-lighten3);
    border-bottom: 0;
    width: 100%;
  }

  .theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(
      .v-btn--outlined
    ).add-cart-button {
    background-color: var(--v-success-darken1) !important;
    font-size: 1rem !important;
    color: var(--v-BAMGrey-base);
  }
  .theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(
      .v-btn--outlined
    ).add-cart-button {
    background-color: var(--v-primary-lighten3) !important;
    color: var(--v-BAMGrey-base);
    border: 0 !important;
  }
  .theme--dark.v-btn.v-btn--disabled.add-cart-button .v-icon {
    color: var(--v-BAMGrey-base) !important;
  }
}
</style>
